import { getTeamsBackgroundState } from './trackTeamsBackgroundState';

export default function (
    callback: (isVisible: boolean) => void
): ReturnType<typeof self.requestAnimationFrame> | undefined {
    // requestAnimationFrame won't get called if the page is not visible. So let's make sure the page is
    // currently visible. If not, then let's end the action here as there is no render time
    if (isPageVisible()) {
        /* eslint-disable-next-line no-restricted-properties -- (https://aka.ms/OWALintWiki)
         * This is intended as this is the wrapper everyone should be using */
        return self.requestAnimationFrame(function endActionWithTime() {
            callback(true);
        });
    } else {
        // If the page is not visible, we should call the callback within a new task
        setTimeout(() => {
            callback(false);
        }, 0);
        return undefined;
    }
}

function isPageVisible(): boolean {
    const isRunningInHostedCalendar = self.window.location?.pathname?.includes('/hosted/calendar/');

    // Check if the page is visible in OWA, Monarch and Teams client respectively
    // Calendar app running as an iframe in Teams client, get the app cached state to determine if the app is visible
    return isRunningInHostedCalendar
        ? !getTeamsBackgroundState()
        : self.document?.visibilityState === 'visible';
}
